import { render, staticRenderFns } from "./type9.vue?vue&type=template&id=033e6f50&scoped=true&"
import script from "./type9.vue?vue&type=script&lang=js&"
export * from "./type9.vue?vue&type=script&lang=js&"
import style0 from "./type9.vue?vue&type=style&index=0&id=033e6f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e6f50",
  null
  
)

export default component.exports